export default function navigationProps(key: string | number) {
  const storageKey = `${key}-nav-props`;

  return {
    get() {
      const props = localStorage.getItem(storageKey);
      const currentProps = props && JSON.parse(props);
      return currentProps as { [key: string]: any } | undefined;
    },
    set(navProps = {}, overwrite = true) {
      if (overwrite) {
        localStorage.setItem(storageKey, JSON.stringify(navProps));
      } else {
        const props = localStorage.getItem(storageKey);
        const previousProps = props && JSON.parse(props);

        localStorage.setItem(storageKey, {
          ...(typeof previousProps === "object" ? previousProps : {}),
          ...navProps
        });
      }
    },
    clear() {
      localStorage.removeItem(storageKey);
    }
  };
}
